import i18n from "@plugins/i18n.ts";
import { notNull } from "@utils/var.check";
import DOMUtils from "@utils/dom.utils";
import SecurityUtils from "@utils/security.utils";

export default function (editor) {
  const TOOLTIP_TAG_SELECTOR = "a.custom-tooltip";
  const TOOLTIP_CLASS = "custom-tooltip";

  const richTextEditor = editor.options.get("richTextEditor");
  (function init() {
    // register the rich text common functions for STP.
    richTextEditor.plugins["tooltip"] = {
      containPluginElements,
    };
  })();
  function containPluginElements(container) {
    return container.querySelectorAll(TOOLTIP_TAG_SELECTOR).length > 0;
  }

  function isOnlyTextSelected(selection, anchorElm) {
    var html = selection.getContent();

    // Partial html and not a fully selected anchor element
    if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf("href=") === -1)) {
      return false;
    }

    if (anchorElm) {
      var nodes = anchorElm.childNodes,
        i;

      if (nodes.length === 0) {
        return false;
      }

      for (i = nodes.length - 1; i >= 0; i--) {
        if (nodes[i].nodeType !== 3) {
          return false;
        }
      }
    }
    let node = selection.getNode();
    if (node.matches("strong, em")) {
      return false;
    }
    return true;
  }
  let openDialog = function (tooltipData) {
    return editor.windowManager.open({
      title: i18n.t("tinymce_plugin_tooltip_modal_title"),
      body: {
        type: "panel",
        items: [
          {
            type: "input",
            name: "label",
            label: i18n.t("tinymce_plugin_tooltip_form_label_display_text"),
          },
          {
            type: "textarea",
            name: "tip",
            label: i18n.t("tinymce_plugin_tooltip_form_label_tooltip"),
          },
        ],
      },
      initialData: {
        label: tooltipData && tooltipData.label ? tooltipData.label : "",
        tip: tooltipData && tooltipData.tip ? tooltipData.tip : "",
      },
      buttons: [
        {
          type: "cancel",
          text: i18n.t("tinymce_plugin_tooltip_modal_button_close"),
        },
        {
          type: "submit",
          text: i18n.t("tinymce_plugin_tooltip_modal_button_save"),
          buttonType: "primary",
        },
      ],
      onSubmit: function (api) {
        const formData = api.getData();
        const targetNode = editor.dom.getParent(editor.selection.getNode(), TOOLTIP_TAG_SELECTOR);
        const onlyText = isOnlyTextSelected(editor.selection, targetNode);
        const linkAttr = {
          href: "#",
          title: formData.tip ? SecurityUtils.sanitizeText(formData.tip) : null,
          class: "custom-tooltip",
        };
        //update existing
        if (targetNode) {
          if (onlyText) {
            if ("innerText" in targetNode) {
              targetNode.innerText = formData.label;
            } else {
              targetNode.textContent = formData.label;
            }
            editor.dom.setAttribs(targetNode, linkAttr);
          }
          editor.dom.setAttribs(targetNode, linkAttr);
        } else {
          if (onlyText) {
            const content = createTooltipTag(formData);
            editor.insertContent(content.outerHTML);
          } else {
            // doesnt handle text change
            editor.execCommand("mceInsertLink", false, linkAttr);
          }
        }

        editor.save();

        api.close();
      },
    });
  };

  function createTooltipTag(data) {
    let tag = document.createElement("a");
    tag.setAttribute("href", "#");
    tag.setAttribute("class", "custom-tooltip");
    tag.setAttribute("title", data.tip);
    tag.appendChild(document.createTextNode(data.label));
    return tag;
  }

  function retrieveDataFromTooltip(element) {
    return {
      tip: element.getAttribute("title"),
      label: element.textContent,
    };
  }
  function handleTooltipElementSelected(buttonApi) {
    const nodeChangeHandler = function (eventApi) {
      let content = editor.selection.getContent(),
        node = editor.selection.getNode(),
        nodeName = node.nodeName,
        nodeClass = node.getAttribute("class");

      if (!nodeClass) {
        nodeClass = "";
      }
      // to determine if the selection has tooltip element.
      const isActive = eventApi.parents.some((parent) => {
        return editor.dom.hasClass(parent, TOOLTIP_CLASS);
      });
      const linkButton = DOMUtils.elOf(
        editor.editorContainer,
        `button[aria-label="Insert/edit link"]`,
      )[0];
      if (linkButton && isActive) {
        DOMUtils.removeClass(linkButton, "tox-tbtn--enabled");
      }
      buttonApi.setActive(isActive);

      const isDisabled =
        nodeName != "P" || nodeName == "DIV"
          ? (notNull(nodeClass) && nodeClass.includes("media-component")) ||
            content.includes("media-component")
          : content.includes("media-component");

      buttonApi.setEnabled(!isDisabled);
    };

    // onSetup should always return the unbind handlers.
    editor.on("NodeChange", nodeChangeHandler);
    return function () {
      return editor.off("NodeChange", nodeChangeHandler);
    };
  }

  editor.ui.registry.addToggleButton("tooltip", {
    tooltip: i18n.t("tinymce_plugin_tooltip_icon_button_tooltip"),
    icon: "comment",
    onAction: function () {
      let tooltipData = {};
      let selection = editor.selection;
      let targetNode = selection.getNode();
      if (!targetNode.matches(TOOLTIP_TAG_SELECTOR)) {
        targetNode = editor.dom.getParent(selection.getNode(), TOOLTIP_TAG_SELECTOR);
      }
      //if found the customtooltip
      if (targetNode) {
        editor.selection.select(targetNode);
        tooltipData = retrieveDataFromTooltip(targetNode);
      } else {
        //if new selection
        tooltipData = {
          label: selection.getContent({ format: "text" }),
          tip: "",
        };
      }
      openDialog(tooltipData);
    },
    onSetup: handleTooltipElementSelected,
  });
}
